import {
  CLEAR_ERRORS_CUSTOMERS_COMMENT,
} from 'pages/Customers/CustomersComments/ClearErrorsComments/actionTypes';

export const clearErrorsComment = (comments) => (
  { type: CLEAR_ERRORS_CUSTOMERS_COMMENT, comments });
